import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.SET_LOCATION](state, location) {
    state.business = location
  },
  // [types.SET_DEVICES](state, devices) {
  //   state.devices = []
  //   for (let element of devices) {
  //     state.devices.push({
  //       value: element.Id,
  //       name: element.FriendlyName
  //     })
  //   }
  //   storage.local.setItem(types.SESSION_DEVICES, JSON.stringify(state.devices))
  // },
  [types.SET_DEVICES](state, devices) {
    state.devices = devices
  },
  [types.SET_DEVICE_TYPES](state, deviceTypes) {
    state.deviceTypes = []
    for (let element of deviceTypes) {
      state.deviceTypes.push({
        value: element.Id,
        name: element.DevicetypeDescription
      })
    }
    storage.local.setItem(types.SESSION_DEVICE_TYPES, JSON.stringify(state.deviceTypes))
  },
}
